import React, { useCallback, useContext, useEffect, useState } from 'react';

import { TableCell } from '@material-ui/core';

import { IHoleResult } from '../../../../../../../../../store/admin/holeResults/store';

import { inchesToFeetAndInches } from '../../../../../../../../../contrib/Utils/inchesToFeetAndInches';
import { EditableDistanceFields } from '../../../../../../../../common/EditableDistanceFields/EditableDistanceFields';
import Button from '../../../../../../../../../components/Button';
import { useBoolean } from '../../../../../../../../common/Hooks/useBoolean.hook';
import { StyledCTPTAbleSubRow } from './CTPTAbleSubRow.Styles';
import { feetAndInchesToInches } from '../../../../../../../../../contrib/Utils/feetAndInchesToInches';
import { GlobalContext } from '../../../../../../../../../store';

interface IProps {
  expandRow: (rowIndex: number) => () => void;
  index: number;

  hole: string;
  holeResult?: IHoleResult;
  isSubRow?: boolean;
  roundId: number;
}

export const CTPTAbleSubRow: React.FunctionComponent<IProps> = props => {
  const { expandRow, index, hole, holeResult, isSubRow, roundId } = props;

  const {
    actions: {
      adminHoleResults: { save: saveHoleScores, get: getHoleResults }
    }
  } = useContext(GlobalContext);

  const [feet, setFeet] = useState<number>(0);
  const [inches, setInches] = useState<number>(0);

  const [editMode, , toggleEditMode] = useBoolean(false);

  useEffect(() => {
    if (holeResult && !editMode) {
      const processedDistance = inchesToFeetAndInches(holeResult.pinDistance);

      if (processedDistance) {
        setFeet(processedDistance.feet);
        setInches(processedDistance.inches);
      }
    }
  }, [holeResult, editMode]);

  const save = useCallback(async () => {
    if (holeResult) {
      const { groupId, scoreId } = holeResult;

      await saveHoleScores(groupId, {
        [scoreId]: {
          id: scoreId,
          pin_distance: feetAndInchesToInches({ feet, inches })
        }
      });

      await getHoleResults(roundId, true);

      toggleEditMode();
    }
  }, [holeResult, feet, inches]);

  const remove = useCallback(async () => {
    if (holeResult) {
      const { groupId, scoreId } = holeResult;

      await saveHoleScores(groupId, {
        [scoreId]: {
          id: scoreId,
          pin_distance: null
        }
      });

      await getHoleResults(roundId, true);
    }
  }, [holeResult, feet, inches]);

  return (
    <StyledCTPTAbleSubRow
      id={`clickableRowResult-${index}`}
      onClick={isSubRow ? () => null : expandRow(index)}
      className="results-table-table-body-row"
    >
      <TableCell className="index">{!isSubRow && Number(hole) + 1}</TableCell>

      <TableCell className="playerName">
        {holeResult ? `${holeResult.userFirstName[0]}. ${holeResult.userLastName}` : '-'}
      </TableCell>

      <TableCell className="distance">
        <div className="distance">
          {holeResult ? (
            <EditableDistanceFields
              feet={feet}
              inches={inches}
              setFeet={setFeet}
              setInches={setInches}
              editMode={editMode}
            />
          ) : (
            '-'
          )}
        </div>
      </TableCell>

      <TableCell className="subrow-actions">
        <div className="wrapper">
          {isSubRow && (
            <>
              <Button
                variant="outlined"
                color="primary"
                type="button"
                className="button "
                onClick={editMode ? save : toggleEditMode}
              >
                {editMode ? 'Save' : 'Edit'}
              </Button>

              <Button
                color="primary"
                type="button"
                className="button "
                onClick={editMode ? toggleEditMode : remove}
              >
                {editMode ? 'Cancel' : 'Remove'}
              </Button>
            </>
          )}
        </div>
      </TableCell>
    </StyledCTPTAbleSubRow>
  );
};
